import React, { useState, PropsWithChildren } from "react";
import { Modal, Button } from "react-bootstrap";

export default function EFMEModal(
    props: PropsWithChildren<{
        title: string;
        show: boolean;
        onClose: () => void;
    }>
): JSX.Element {
    return (
        <Modal show={props.show} onHide={props.onClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title style={{ color: "blue" }}>
                    {props.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12">{props.children}</div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={props.onClose}
                    style={{ float: "right" }}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
